/*
Disabled
----------------------------------------------------------------
disabledの挙動のためのjs
*/
{
	// aタグ
  if ($('a[disabled]').length) {
    $('a[disabled]').addClass('disabled');
    $('a[disabled]').removeAttr('href');
    $(document).on('click', 'a[disabled]', function(event) {
      return false;
    });
  }

  // Switch
  if ($('.has-switch.deactivate').length) {
  	console.log('.has-switch.deactivate');
    $(document).on('click', '.has-switch.deactivate', function(event) {
      return false;
    });
  }

  // navbar内dropdown
  if ($('.navbar-nav .dropdown.disabled').length) {
    $('.navbar-nav .dropdown.disabled > a').addClass('disabled').attr('disabled','disabled');
  }
  if ($('.navbar-nav .dropdown > a[disabled]').length) {
    $('.navbar-nav .dropdown > a[disabled]').parent('li.dropdown').addClass('disabled');
    $('.navbar-nav .dropdown > a[disabled]').addClass('disabled');
  }
  if ($('.navbar-nav .dropdown > a.disabled').length) {
    $('.navbar-nav .dropdown > a.disabled').parent('li.dropdown').addClass('disabled');
    $('.navbar-nav .dropdown > a.disabled').attr('disabled','disabled');
  }
}
